/**
 * Validation Helpers for Admin Onboarding and User Modifications
 */

/**
 * Validates 10-digit Indian Mobile Number (starts with 6-9)
 */
export function isValidIndianMobile(mobile) {
  if (!mobile) return false;
  const cleaned = String(mobile).trim().replace(/\D/g, "");
  // Strip optional +91 or 91 country code prefix if 12 digits
  const tenDigit = cleaned.length === 12 && cleaned.startsWith("91") ? cleaned.slice(2) : cleaned;
  return /^[6-9]\d{9}$/.test(tenDigit);
}

/**
 * Normalizes an Indian mobile number to 10 digits
 */
export function normalizeMobile(mobile) {
  if (!mobile) return "";
  const cleaned = String(mobile).trim().replace(/\D/g, "");
  return cleaned.length === 12 && cleaned.startsWith("91") ? cleaned.slice(2) : cleaned;
}

/**
 * Validates Indian Bank IFSC Code (4 letters, 0, 6 alphanumeric characters)
 */
export function isValidIFSC(ifsc) {
  if (!ifsc) return false;
  return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(String(ifsc).trim().toUpperCase());
}

/**
 * Validates Indian Bank Account Number (numeric, 9 to 18 digits)
 */
export function isValidBankAccount(acc) {
  if (!acc) return false;
  const cleaned = String(acc).trim().replace(/\s+/g, "");
  return /^\d{9,18}$/.test(cleaned);
}

/**
 * Validates Standard Email Address
 */
export function isValidEmail(email) {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}

/**
 * Validates UCC (Unique Client Code) - typically 4-12 alphanumeric characters
 */
export function isValidUCC(ucc) {
  if (!ucc) return false;
  return /^[A-Z0-9]{3,12}$/i.test(String(ucc).trim());
}

/**
 * Validates DP Client ID (typically 8 numeric digits)
 */
export function isValidClientId(clientId) {
  if (!clientId) return false;
  const cleaned = String(clientId).trim().replace(/\D/g, "");
  return cleaned.length >= 4 && cleaned.length <= 16;
}
